import React, { useState, useEffect } from 'react';

const Reportes = ({ menus: initialMenus }) => {
  const [menus, setMenus] = useState(Array.isArray(initialMenus) ? initialMenus : []);

  // Cuando cambian las props, actualizoel estado
  useEffect(() => {
    if (Array.isArray(initialMenus)) {
      setMenus(initialMenus);
    }
  }, [initialMenus]);

  const checkMenu = (menu, option) => {
    if (Array.isArray(menus)) {
      const updatedMenus = menus.map(menuArray => {
        if (menu.id === menuArray.id) {
          return { ...menuArray, [option]: !menuArray[option] };
        }
        return menuArray;
      });
      console.log("menu Actualizado nuevo reportes", updatedMenus);
      setMenus(updatedMenus);
    }
  };

  return (
    <>
      {Array.isArray(menus) &&
        menus.map(menu => (
          <tr key={menu.id}>
            <td>
              {menu.parent > 0 ? (
                <p name="menuName">{menu.nombre}</p>
              ) : (
                <h4 className="weight-bold" name="menuName">
                  {menu.nombre}
                </h4>
              )}
            </td>
            <td>
              <div className="row justify-end">
                {menu.parent > 0 && (
                  <label className="container-check">
                    <input
                      type="checkbox"
                      name="lectura"
                      checked={!!menu.lectura}
                      onChange={() => checkMenu(menu, 'lectura')}
                    />
                    <span className="checkmark"></span>
                  </label>
                )}
              </div>
            </td>
            <td>
              <div className="row justify-end">
                {menu.parent > 0 && (
                  <label className="container-check">
                    <input
                      type="checkbox"
                      name="escritura"
                      checked={!!menu.escritura}
                      onChange={() => checkMenu(menu, 'escritura')}
                    />
                    <span className="checkmark"></span>
                  </label>
                )}
              </div>
            </td>
          </tr>
        ))}
    </>
  );
};

export default Reportes;
